<template>
    <div class="page orders-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="ordersMeta">
                    <crud-table hide-create :actions="actions" show-search search-placeholder="ابحث بـ #رقم الطلب، بيانات العميل والتوصيل" server-pagination :page-count="ordersMeta.last_page" :current-page="ordersMeta.current_page" :total="ordersMeta.total" :per-page="ordersMeta.per_page" title="الطلبات" :items="ordersItems" :headers="headers" @open="openOrder" @load="loadMore" @search="searchHandler" @reset="reset" @create="createDialog = true" @delete="openDeleteDialog" @print="openPrintDialog" @edit="openEditDialog" :export-url="exportUrl" />
                </div>
            </transition>


            <action-dialog v-model="editDialog" scrollable max-width="420" vuex-action="editOrder" success-msg="تم حفظ التغييرات بنجاح" title="تعديل الطلب" subtitle="سيتم تنفيذ التغييرات لحظياً" button-text="تعديل" :data="{id: editedItem.id, data: editedItem}" @reset="resetEditForm">
                <div class="pt-1">
                    <v-text-field v-model="editedItem.name" label="اسم الطلب" placeholder="أدخل اسم الطلب" hide-details class="mb-5"></v-text-field>
                    <v-select v-model="editedItem.categories" multiple label="اﻷقسام" placeholder="اختر اﻷقسام" hide-details :items="categoriesListItems" class="mb-5">
                        <template v-slot:selection="{item}">
                            <v-chip color="surface2" label small :key="item.value">
                                <v-icon size="14" class="me-1" left>mdi-view-grid-outline</v-icon>
                                {{item.text}}
                            </v-chip>
                        </template>
                    </v-select>
                    <v-select v-model="editedItem.hidden" label="ظهور الطلب" :items="[{text:'الظهور مفعل', value: false}, {text: 'مخفي من المتجر', value: true}]" placeholder="اختر ظهور الطلب" hide-details class="mb-5"></v-select>

                    <v-checkbox v-model="editedItem.track_stock" label="تفعيل إدارة المخزون" color="primary" class="mb-3" hide-details></v-checkbox>
                    <v-checkbox v-model="editedItem.featured" label="تحديد كطلب مميز" color="orange darken-1" class="mb-3" hide-details></v-checkbox>
                </div>
            </action-dialog>

            <action-dialog v-model="deleteDialog" vuex-action="deleteOrder" :title="`حذف الطلب #${deleteItem ? deleteItem.item_id : ''}`" :data="{id: deleteItem ? deleteItem.id : null}" button-text="تأكيد الحذف" button-color="error" success-msg="تم حذف الطلب بنجاح">
                هل أنت متأكد من حذف الطلب <span class="strong-text--text">"#{{deleteItem ? deleteItem.local_serial : ''}}"</span> نهائياً ؟
                لن تتمكن من التراجع عن هذه الخطوة
            </action-dialog>
            
            <order-invoice-dialog v-if="printOrder" v-model="printDialog" :order="printOrder" />
        </v-container>

    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CrudTable from '@/components/default/crud-table'
import OrderInvoiceDialog from '@/components/custom/order-invoice-dialog'

export default {
    name: "Orders",
    components: {
        CrudTable,
        OrderInvoiceDialog
    },
    data(){
        return {
            loading: false,   
            createDialog: false,
            newOrder: {
                name: '',
                categories: [],
                // wholesale_price: '',
                price: '',
                image: null,
                track_stock: false,
                stock: '',
                hidden: false,
                featured: false,
            },

            printDialog: false,
            printOrder: null,

            editDialog: false,
            editedItem: {
                id: '',
                name: '',
                categories: [],
                track_stock: false,
                hidden: false,
                featured: false,
            },

            deleteDialog: false,
            deleteItem: null,


            orderStatusItems: [
                {text: 'انتظار القبول', value: 'review', color: 'blue-grey', icon: 'mdi-file-document-outline'},
                {text: 'جاري التجهيز', value: 'in_progress', color: 'blue-grey', icon: 'mdi-package-variant'},
                {text: 'جاري التوصيل', value: 'in_delivery', color: 'orange darken-2', icon: 'mdi-truck-fast-outline'},
                {text: 'تم التوصيل', value: 'delivered', color: 'indigo', icon: 'mdi-truck-check-outline'},
                {text: 'طلب مكتمل', value: 'completed', color: 'success', icon: 'mdi-check-circle-outline'},
                {text: 'طلب ملغي', value: 'canceled', color: 'red', icon: 'mdi-close-circle-outline'},
                {text: 'طلب مرتجع', value: 'returned', color: 'deep-orange', icon: 'mdi-login'},
            ],

            headers: [
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'item_id',
                },
                {
                    text: 'الطلب',
                    align: 'start',
                    sortable: false,
                    value: 'main_image_url',
                    avatarText: 'orderName',
                    avatar: true,
                    avatarIcon: 'orderIcon',
                    bordered: true,
                    width: 45,
                    height: 45,
                    href: 'orderTo',
                    color: 'primary',
                },
                {
                    text: 'كوبون الخصم',
                    value: 'coupon_discount',
                    align: 'center',
                    sortable: false,
                    money: true,
                    weight: 'medium',
                },
                {
                    text: 'الإجمالي بعد الخصم',
                    value: 'total',
                    align: 'center',
                    sortable: false,
                    money: true,
                    color: 'strong-text',
                },
                {
                    text: 'الإجمالي + التوصيل',
                    value: 'total_with_delivery',
                    align: 'center',
                    sortable: false,
                    money: true,
                    color: 'strong-text',
                    weight: 'medium',
                },
                {
                    text: 'العميل',
                    value: 'name',
                    align: 'start',
                    sortable: false,
                },
                {
                    text: 'رقم الهاتف',
                    value: 'phoneComputed',
                    align: 'start',
                    sortable: false,
                    ltr: true,
                },
                {
                    text: 'حالة الطلب',
                    align: 'center',
                    sortable: false,
                    value: 'status',

                    chip: true,
                    chipFunction: this.getStatusChip,
                },
                {
                    text: 'وقت اﻹنشاء',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        ...GlobalComputed,
        orders(){
            return this.$store.state.ordersModule.orders;
        },
        categories(){
            return this.$store.state.ordersModule.ordersCategories;
        },
        categoriesListItems(){
            return this.categories ? this.categories.map(category=>{
                return {
                    value: category.id,
                    text: category.name
                }
            }) : [];
        },
        ordersMeta(){
            return this.$store.state.ordersModule.ordersMeta;
        },
        ordersItems(){
            return this.orders ? this.orders.map(order=>{
                let orderIcon = 'mdi-cart';
                let orderColor = 'primary';

                if (order.status === 'completed'){
                    orderIcon = 'mdi-check-circle'
                    orderColor = 'success'
                }else if (order.status === 'canceled'){
                    orderIcon = 'mdi-close-circle'
                    orderColor = 'error'
                }
                return {
                    ...order,
                    orderName: `طلب رقم #${order.local_serial}`,
                    item_id: order.local_serial,
                    orderTo: {name: 'order', params: {id: order.id}},

                    phoneComputed: order.phone_code + order.phone,
                    
                    total_with_delivery: order.delivery_price ? order.total + order.delivery_price : order.total,
                    
                    orderIcon,
                    orderColor,
                };
            }) : [];
        },
        actions(){
            return [
                {name: 'open', text: 'عرض الطلب', icon: 'mdi-open-in-new', color: 'primary'},
                {name: 'print', text: 'طباعة الطلب', icon: 'mdi-printer', color: 'strong-text'},
                {name: 'edit', text: 'تعديل', icon: 'mdi-square-edit-outline', color: 'text'},
                {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'red darken-1'}
            ]
        },
        searchQuery(){
            return this.$route.query.search;
        },
        exportUrl(){
            return `${window.apiUrl}/orders/export`;
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        searchQuery(query){
            this.loadData();
        }
    },
    methods: {
        ...GlobalMethods,
        loadData(page=1){
            if (!this.loading){
                this.loading = true;
                const query = this.searchQuery || null;
                this.$store.dispatch('getOrders', {page, query}).then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل الطلبات', 'error');
                })
            }
        },
        getStatusChip(status){
            const chip = this.orderStatusItems.find(item=>item.value === status);
            if (chip){
                return chip;
            }else{
                return {text: status, color: 'primary', icon: 'mdi-flag-outline'}
            }
        },
        loadMore(payload){
            this.loadData(payload.page);
        },
        reset(){
            if (this.searchQuery){
                this.$router.replace({query: {}})
            }
            this.loadData();
        },
        openOrder(order){
            this.$router.push({name: 'order', params: {id: order.id}});
        },
        searchHandler(search){
            this.$router.replace({query: {search}})
        },
        resetCreateForm(){
            this.newOrder = {
                name: '',
                categories: [],
                // wholesale_price: '',
                price: '',
                image: null,
                track_stock: false,
                stock: '',
                hidden: false,
                featured: false,
            };
        },
        openEditDialog(item){
            for(let key in this.editedItem){
                if (key === 'categories'){
                    this.editedItem.categories = item.categories.map(c=>c.id);
                }else{
                    this.editedItem[key] = item[key];
                }
            }
            // Object.assign(this.editedItem, item);
            this.editDialog = true;
        },
        openPrintDialog(order){
            this.printOrder = order;
            this.printDialog = true;
        },
        resetEditForm(){
            this.editedItem = {
                id: '',
                name: '',
                categories: [],
                track_stock: false,
                hidden: false,
                featured: false,
            };
        },
        openDeleteDialog(item){
            this.deleteDialog = true;
            this.deleteItem = item;
        },
    },
    mounted(){
        this.loadData();
    }
};
</script>
